import React from 'react';
import { isFragment } from 'react-is';
export function traverseReactNode(children, fn) {
    let i = 0;
    function handle(target) {
        React.Children.forEach(target, (child) => {
            var _a;
            if (!isFragment(child)) {
                fn(child, i);
                i + 1;
            }
            else {
                handle((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children);
            }
        });
    }
    handle(children);
}
